


let enabled = false;

export const setReduxLogEnabled = (v: boolean) => { enabled = v; };
export const isReduxLogEnabled = () => enabled;


//middleware console logger to keep logs of actions even over hard page refresh / navigation
//enable persistent logs in chrome dev tool settings
const ReduxLogger = (_store: any) => (next: any) => (action: any) => {

    if (!isReduxLogEnabled()) return next(action);

    // Log action + payload
    // Use groupCollapsed to keep it readable
    try {
        console.groupCollapsed(
            "%c[redux]%c %s", //string format
            "font-weight:700;color:#839bf2;", // first %c style for the [redux] label
            "font-weight:400;color:inherit;", //second %c style for the action type
            ` ${action?.type ?? 'unknown'}` //the %s value to inject into the string format
        );

        console.log(action);

        console.groupEnd();

        const result = next(action);

        return result;
    } catch (e) {
        // If logging blows up for some reason, don't break dispatch
        console.warn(`[redux] - consoleLogger exception`, e);
        return next(action);
    }
};

export default ReduxLogger